const tab_sections = {
    overview: '概览',
    authentication: '身份验证',
    authorization: '授权',
    users: '用户',
    developer: '开发者',
    tenant: '租户',
};
export default Object.freeze(tab_sections);
